import { Collapse } from "@mui/material";
import styled from "styled-components";
import { THEME } from "../../../../styles/theme";
import { Button } from "../../../../components";

export const Container = styled.div`
  position: relative;
  > div {
    cursor: default;
  }
`;

export const DetailsCollapse = styled(Collapse)`
  position: absolute;
  z-index: 2;

  width: 100%;
  margin-top: 0.5rem;
  border-radius: 1rem;
`;
export const DetailsCotainer = styled.div`
  width: calc(100% - 2rem);
  height: 10rem;

  padding: 1rem;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  border-radius: 1rem;
  background-color: #212325;
`;

export const UnitRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  margin-bottom: 1rem;

  img {
    border-radius: 1rem;
    width: 5rem;
    height: 5rem;
    object-fit: cover;
  }
`;

export const DetailsBox = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
    gap: 1rem;
    > span {
      width: 3rem;
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 1rem;
      /* background-color: white; */
      /* border: 0.5px solid ${THEME.palette.primary.main}; */
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
      svg {
        margin-top: -1.3rem;
        width: 0.8rem;
        height: 0.8rem;
      }
      .middle {
        margin-top: -1.5rem;
      }
    }
  }
`;
export const StarsContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: -3.5rem;
`;

export const SeeMoreButton = styled(Button)`
  position: absolute;
  z-index: 3;
  right: 0;
  top: 10px;
  border-radius: 2rem;
  padding-left: 1rem;
`;
